import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const APPROACH_IMAGE = '/img/site_imgs/our_approach.jpg';

function Approach(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div id="approach" className="lf-bg-white lf-section-anchor">
      <div className="lf-editorial lf-section py-5">
        <div className="row align-items-center">
          <div className="col-lg-7 lf-reveal">
            <p className="lf-eyebrow">{floral.approach.eyebrow[language]}</p>
            <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.24, letterSpacing: '-0.04em' }}>
              {floral.approach.title[language]}
            </h2>
            <p className="mt-4" style={{ color: 'var(--lf-muted)', lineHeight: 1.6 }}>
              {floral.approach.bodyOne[language]}
            </p>
            <p className="mt-3" style={{ color: 'var(--lf-muted)', lineHeight: 1.6 }}>
              {floral.approach.bodyTwo[language]}
            </p>
          </div>
          <div className="col-lg-5 lf-reveal mt-4 mt-lg-0">
            <div className="lf-image-frame" style={{ aspectRatio: '4 / 5' }}>
              <img src={APPROACH_IMAGE} alt="A close-up arrangement of blush and peach roses and ranunculus with dark foliage." loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Approach };
